import { LooseAutocomplete, Timestamp } from '../utils';

export interface VerifiedMemberInfo {
  tenantId: string;
  confirmedByEmail: boolean;
  member: MemberProperties;
  other: MemberProperties[];
  auxiliary: MemberProperties[];
  verifiedMember?: VerifiedMember;
}

interface VerifiedMember {
  id: number;
  membershipId: number;
  categoryId: string;
  name: string;
  membershipCategory: string;
  externalMembershipId: string;
  acmeBarcode: string;
  email: string;
  auxiliary: boolean;
}

interface MemberProperties {
  membershipId: number;
  name: string;
  firstName: string;
  lastName: string;
  categoryId: string;
  externalMembershipId: string;
  membershipStanding: LooseAutocomplete<'active' | 'lapsed'>;
  membershipExpirationDate: Timestamp;
  acmeMembershipNumber: string;
}

export function scrubMembership<T extends Partial<{ name: string; lastName: string; email: string }>>(membership: T) {
  if (membership.name) {
    membership.name = membership.name.slice(0, 1);
  }

  if (membership.lastName) {
    membership.lastName = membership.lastName.slice(0, 1);
  }

  if (membership.email) {
    membership.email = membership.email.slice(0, 4);
  }

  return membership;
}
